import styled from 'styled-components';

export const SwitchBtn = styled.div`
		display: flex;
		min-width: 40px;
		position: relative;

		.switch {
			position: relative;
			display: inline-block;
			width: 34px;
			height: 15px;

		input {
			opacity: 0;
			width: 0;
			height: 0;
		}
	}

	.slider {
		position: absolute;
		inset: 0;
		background-color: var(--toggleTrackColor);
		transition: background-color 0.3s ease;
		border-radius: 20px;
		cursor: pointer;

		&:before {
			content: "";
			position: absolute;
			height: 21px;
			width: 21px;
			left: -4px;
			top: -5px;
			background-color: var(--toggleThumbColor);
			border: 1px solid #f5f5f5;
			border-radius: 50%;
			box-shadow: 0 0.5px 5px rgba(0, 0, 0, 0.1);
			transition: transform 0.3s ease;
		}
	}

	.checkbox:disabled + .slider {
		cursor: not-allowed;
		opacity: .6;
	}

	input:checked + .slider {
		background-color: var(--primary);
	}

	input:checked + .slider:before {
		transform: translateX(19px);
	}

	&.showpanel-toggle{
		.switch {
			width: 34px;
			height: 14px;
		}
		.slider{
			&:before{
				height: 21px;
				width: 21px;
				top: -5px;
			}
		}
		input:checked + .slider::before {
			transform: translateX(18px);
		}	
	}
`;
